import '../../_common/components/ask-ai-button';

import {
  type AffineFormatBarWidget,
  toolbarDefaultConfig,
} from '@blocksuite/affine/blocks';
import { html, type TemplateResult } from 'lit';
import { AIStarIcon } from '@blocksuite/affine/blocks';

import { pageAIGroups } from '../../_common/config';
import { getAIPanelWidget } from "@affine/core/blocksuite/presets/ai/utils/ai-widgets";
import { AIProvider } from "@affine/core/blocksuite/presets/ai";

export function setupFormatBarAIEntry(formatBar: AffineFormatBarWidget) {
  toolbarDefaultConfig(formatBar);

    // 可以添加更多过滤或处理逻辑...
  formatBar.addRawConfigItems(
    [
      {
        type: 'custom' as const,
        render(formatBar: AffineFormatBarWidget): TemplateResult | null {
          return html`
            <ask-ai-toolbar-button
              .host=${formatBar.host}
              .actionGroups=${pageAIGroups}
            ></ask-ai-toolbar-button>
          `;
        },
      },
      { type: 'divider' },
    ],
    0
  );
  formatBar.addRawConfigItems(
    [
      {
        type: 'custom' as const,
        render(formatBar: AffineFormatBarWidget): TemplateResult | null {
          return html`
            <div
              @click=${() => {
                const panel = getAIPanelWidget(formatBar.host);
                AIProvider.slots.requestOpenWithChat.emit({
                  host: formatBar.host,
                  appendCard: true,
                  tabId: 'match'
                });
                panel.hide();
              }}
              style="
                color: var(--affine-brand-color);
                font-size: var(--affine-font-sm);
                font-weight: 500;
                padding: 4px;
                display: flex;
                gap: 4px;
                cursor: pointer;
              "
            >
              ${AIStarIcon}
              理论匹配
            </div>
          `;
        },
      },
      { type: 'divider' },
    ],
    0
  );
  const overrideConfig = {
    Attachment: {
      name: '附件',
      description: '添加附件',
    },
    Image: {
      name: '图片',
      description: '添加图片',
    },
    Equation: {
      name: '公式',
      description: '添加公式',
    },
    Text: {
      name: '正文',
      description: '',
    },
    Bold: {
      name: '黑体',
      description: '',
    },
    Italic: {
      name: '斜体',
      description: '',
    },
    Underline: {
      name: '下划线',
      description: '',
    },
    Strike: {
      name: '删除线',
      description: '',
    },
    Link: {
      name: '超链接',
      description: '',
    },
    Code: {
      name: '代码',
      description: '',
    },
    'Table View': {
      name: '添加表格',
      description: '',
    },
    'Kanban View': {
      name: '添加看板',
      description: '',
    },
    'Code Block': {
      name: '代码',
      description: '',
    },
    'Heading 1': {
      name: '标题1',
      description: '',
    },
    'Heading 2': {
      name: '标题2',
      description: '',
    },
    'Heading 3': {
      name: '标题3',
      description: '',
    },
    'Other Headings': {
      name: '其他标题',
      description: '',
    },
    'Heading 4': {
      name: '标题4',
      description: '',
    },
    'Heading 5': {
      name: '标题5',
      description: '',
    },
    'Heading 6': {
      name: '标题6',
      description: '',
    },
    'Bulleted List': {
      name: '项目符号',
      description: '',
    },
    'Numbered List': {
      name: '数字编号',
      description: '',
    },
    'To-do List': {
      name: '待办事项',
      description: '',
    },
    'Create Table': {
      name: '创建表格',
    },
    // 可扩展更多菜单项的重写配置
  };
  const itemsToFilter = ['Create Linked Doc','Quote'];

  formatBar.configItems=formatBar.configItems.filter(item => {
    return !itemsToFilter.includes(item.name)
  })
  .map(item => { // 再对剩余项应用重写配置
        const overrides = overrideConfig[item.name];
        return overrides ? { ...item, ...overrides } : item;
      });
}
